import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_item = _resolveComponent("nav-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_account_loader = _resolveComponent("account-loader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_nav_item, {
      icon: "fa fa-user",
      label: "Users",
      description: "Invite, edit, and delete users",
      to: `/admin/accounts/${_ctx.accountId}/users`
    }, null, 8, ["to"]),
    (_ctx.isServiceProvider)
      ? (_openBlock(), _createBlock(_component_nav_item, {
          key: 0,
          icon: "fa fa-building",
          label: "Law Firms",
          description: "View law firms",
          to: `/admin/accounts/${_ctx.accountId}/customers`
        }, null, 8, ["to"]))
      : _createCommentVNode("", true),
    (_ctx.isCustomer)
      ? (_openBlock(), _createBlock(_component_nav_item, {
          key: 1,
          icon: "fa fa-address-book",
          label: "Clients",
          description: "Manage law firm clients",
          to: `/admin/accounts/${_ctx.accountId}/clients`
        }, null, 8, ["to"]))
      : _createCommentVNode("", true),
    (_ctx.isCustomer && _ctx.isGranted('VIEW_PAYMENT_METHODS'))
      ? (_openBlock(), _createBlock(_component_nav_item, {
          key: 2,
          icon: "fa fa-receipt",
          label: "Billing",
          description: "View payment methods & receipts",
          to: `/admin/accounts/${_ctx.accountId}/billing`
        }, null, 8, ["to"]))
      : _createCommentVNode("", true),
    (_ctx.isCustomer && _ctx.isGranted('VIEW_POST'))
      ? (_openBlock(), _createBlock(_component_nav_item, {
          key: 3,
          icon: "fa fa-trash",
          label: "Trash",
          description: "Restore deleted posts",
          to: `/admin/accounts/${_ctx.accountId}/trash`
        }, null, 8, ["to"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_separator),
    (_ctx.isCustomer && _ctx.isGranted('VIEW_SERVICE_ACCOUNTS') && _ctx.hasFeat('INTEGRATIONS'))
      ? (_openBlock(), _createBlock(_component_nav_item, {
          key: 4,
          icon: "fa fa-plug",
          label: "Integrations",
          description: "Connect third-party services",
          to: `/admin/accounts/${_ctx.accountId}/integrations`
        }, null, 8, ["to"]))
      : _createCommentVNode("", true),
    _createVNode(_component_account_loader, {
      "account-id": _ctx.accountId,
      modelValue: _ctx.account,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.account) = $event))
    }, null, 8, ["account-id", "modelValue"])
  ]))
}